import React, { useState } from 'react';
import PropTypes from 'prop-types';
// Components
import Modal from '../../modal';
import CountryModalContent from './country-modal';
// Styles
import { CountrySwitcher, CountryThat, CountryThis, MapNav } from './styles';
// Assets
import England from '../../../assets/images/nav-map-england.svg';
import Scotland from '../../../assets/images/nav-map-scotland.svg';

/**
 * Allows the user to switch between sibling sites
 */
const CountrySwitch = ({ siblingSiteUrl, siblingSiteName }) => {
  const siteCountries = ['England', 'Scotland'];
  const map = { England, Scotland };

  const countries = {
    thatCountry: siblingSiteName,
    thisCountry:
      siblingSiteName === siteCountries[0]
        ? siteCountries[1]
        : siteCountries[0],
  };

  const link = {
    external: true,
    URL: siblingSiteUrl,
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <CountrySwitcher data-testid="country-switcher">
        <MapNav src={map[countries.thisCountry]} alt="" />
        {siteCountries.map((country) =>
          siblingSiteName !== country ? (
            <CountryThis key={`tgl-${country}`} aria-current="location">
              {country}
            </CountryThis>
          ) : (
            <CountryThat
              key={`tgl-${country}`}
              onClick={openModal}
              aria-label={`${countries.thatCountry}: You are on Shelter ${countries.thisCountry}, switch to Shelter ${countries.thatCountry}`}
            >
              {country}
            </CountryThat>
          )
        )}
      </CountrySwitcher>
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <CountryModalContent
          link={link}
          countries={countries}
          closeFn={closeModal}
          thisMap={map[countries.thisCountry]}
        />
      </Modal>
    </>
  );
};

CountrySwitch.propTypes = {
  siblingSiteName: PropTypes.oneOf(['England', 'Scotland']).isRequired,
  siblingSiteUrl: PropTypes.string.isRequired,
};

export default CountrySwitch;
